// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZOZq","colMin":"styles_colMin__2hx9S"};